import * as API from "../../services/httpService"
import { navigate } from "gatsby"
import _ from "lodash"
import {
  pageIncrement,
  controlLoading,
  controlDeclaration,
  updateUiData,
} from "../../redux/actions"
import * as CommonFunction from "../../common/function"
import * as Regex from "../../common/regex"

const SubmitClaim = (dispatch, uiData, claimData) => {
  let submitData = _.cloneDeep(claimData)

  //Check if claimantNricNumber is UEN
  if (submitData.claimFireDetail.claimantNricNumber) {
    const inputNricValue = submitData.claimFireDetail.claimantNricNumber
    const nricRegex = RegExp(Regex.nricpattern)

    if (!nricRegex.test(inputNricValue)) {
      submitData.claimFireDetail.claimantNricNumber = ""
      submitData.claimFireDetail.claimantUEN = inputNricValue
    }
  }

  submitData.claimFireDetail.dateLastSeen = CommonFunction.combineDateAndTime(
    submitData.claimFireDetail.dateLastSeen,
    submitData.claimFireDetail.timeLastSeen
  )

  submitData.claimFireDetail.reportDate = CommonFunction.combineDateAndTime(
    submitData.claimFireDetail.reportDate,
    submitData.claimFireDetail.reportTime
  )

  if (submitData.claimFireDetail.occupation === "Others") {
    submitData.claimFireDetail.occupation =
      submitData.claimFireDetail.otherOccupation
  }

  submitData.claimFireDetail.policyHolderName =
    submitData.claimFireDetail.claimantName
  submitData.claimFireDetail.declaration = uiData.checkBoxStatus.isAgree

  submitData.claimFireDetail.ProductType =
    claimData.claimAttributeModel.ContractType
  //console.log(
  //  JSON.stringify({
  //    claimHeaderModel: submitData.claimFireDetail,
  //    claimFireDetailModel: submitData.claimFireDetail,
  //    claimUploadListModel: uiData.claimUploadListModel,
  //    folderName: uiData.folderName,
  //  })
  //)

  API.apiPostRequest(
    "/Claim/FireHdbSubmitClaim",
    {
      // claimAttributeModel: submitData.claimAttributeModel,
      claimHeaderModel: submitData.claimFireDetail,
      claimFireDetailModel: submitData.claimFireDetail,
      claimUploadListModel: uiData.claimUploadListModel,
      folderName: uiData.folderName,
      // sessionId: "",
    },
    null
  ).then(
    submitClaimResponse => {
      // console.log(submitClaimResponse)
      dispatch(controlDeclaration())
      dispatch(pageIncrement())
      dispatch(
        updateUiData(
          "submittedClaimID",
          submitClaimResponse.data.ClaimRequestNumber
        )
      )

      dispatch(controlLoading())
    },
    error => {
      navigate("errorOccurred")
    }
  )
}

export default SubmitClaim
